// Rust's Exception renders as "Exception[ message:[<msg>] cause:[<cause>] ]"; surface the inner
// message so users see e.g. "Vault 'otc prod' not found" instead of the wrapper.
const unwrapException = (raw: string): string => {
  const match = /message:\[([\s\S]*?)\](?=\s(?:cause:\[|\]))/.exec(raw);
  return (match ? match[1] : raw).trim();
};

// A response body is usually a parsed object, but may arrive as a JSON string.
const toRecord = (value: unknown): Record<string, unknown> | undefined => {
  if (value && typeof value === "object") return value as Record<string, unknown>;
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === "object") return parsed as Record<string, unknown>;
    } catch {
      // not JSON; the caller treats the string as a plain message
    }
  }
  return undefined;
};

export const getErrorMessage = (error: unknown): string => {
  if (!error) return "An unknown error occurred";

  if (typeof error === "string") return unwrapException(error);

  if (typeof error === "object" && "data" in error) {
    const data = (error as { data: unknown }).data;
    const rec = toRecord(data);
    if (rec) {
      // RPC failures return HTTP 400 with the RpcResponse body: { success: false, error }.
      if (rec.message) return unwrapException(String(rec.message));
      if (rec.error) return unwrapException(String(rec.error));
    } else if (typeof data === "string" && data.trim()) {
      return unwrapException(data);
    }
  }

  if (typeof error === "object" && "message" in error && error.message) {
    return unwrapException(String(error.message));
  }

  if (typeof error === "object" && "error" in error && error.error) {
    return unwrapException(String(error.error));
  }

  return "An unknown error occurred";
};
